import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
var Spinner = function () {
    return (_jsx("div", { className: "spinner text-white", children: _jsx(FontAwesomeIcon, { size: "lg", icon: faSpinner, spin: true }) }));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map